import { Drawer, DrawerProps } from 'antd'
import styles from './ADrawer.module.less'
import cls from 'classnames'
import AIcon from '../AIcon/AIcon'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

type Props = Pick<
  DrawerProps,
  'children' | 'open' | 'onClose' | 'className' | 'title' | 'placement' | 'width' | 'height'
> & {
  testId?: string
}

const COMPONENT_NAME = 'A-Drawer'
function ADrawer(props: Props) {
  const { i18n } = useTranslation()
  const classNames = cls(styles[COMPONENT_NAME], styles[i18n.language], props.className)
  const handleClose: typeof props.onClose = (e) => {
    props.onClose!(e)
  }
  return (
    <Drawer
      rootClassName={classNames}
      data-testid={props.testId}
      open={props.open}
      onClose={props.onClose}
      width={props.width}
      height={props.height}
      title={props.title}
      footer={null}
      closeIcon={null}
      extra={<CloseBtn testId={props.testId ? `${props.testId}-close-btn` : undefined} onClick={handleClose} />}
    >
      {props.children}
    </Drawer>
  )
}

function CloseBtn(props: { onClick: (e: MouseEvent<HTMLSpanElement>) => void; testId?: string }) {
  return (
    <span data-testid={props.testId} className={styles[COMPONENT_NAME + '-close-btn']} onClick={props.onClick}>
      <AIcon width={10} type='icon-line-global_close1' />
    </span>
  )
}

export default ADrawer
